import React, { CSSProperties, useState } from 'react';
import styled from 'styled-components';

export interface Data {
  value: string;
  label: string;
}

export interface Props {
  data: Data[];
  groupName: string;
  disabled?: boolean;
  onChange: (selectedValue: string) => void;
  style?: CSSProperties;
}

const Panel = styled.div`
`;

const Item = styled.div`
  display: flex;
  align-items: center;
`;

export const Radioboxes = (props: Props) => {
  const {
    data, disabled, groupName, style,
  } = props;
  const [value, setValue] = useState<string>('');

  const selectRadiobox = (v: string) => {
    setValue(v);
    props.onChange(v);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      selectRadiobox(e.target.value);
    }
  };

  return (
    <Panel style={style}>
      {data.map((d) => (
        <Item key={d.value}>
          <input
            disabled={disabled}
            onChange={onChange}
            type="radio"
            name={groupName}
            style={{ marginRight: '.5rem' }}
            value={d.value}
            checked={d.value === value}
          />
          <label onClick={() => disabled || selectRadiobox(d.value)} style={{ opacity: disabled ? 0.3 : 1 }}>{d.label}</label>
        </Item>
      ))}
    </Panel>
  );
};
